module.exports = __webpack_public_path__ + "public/img/banner-4.16f51d64.jpg";